import { ColumnDef, ColumnSort } from '@tanstack/react-table';
import UserActionButtons from './UserActionButtons';
import moment from 'moment';
import { formatMessage } from 'i18n/CurrentLocale';
import { ColumnVisibility, OptionalColumn } from 'screens/modals/ManageTableColumnsModal';
import { LicensePlate } from 'components/vehicles/LocalisedLicensePlate';


export const usersTableDefaultSorting: ColumnSort[] = [{ id: 'familyName', desc: false, }];

export const USERS_TABLE_DEFAULT_COLUMN_VISIBILITY: ColumnVisibility = {
    givenName: true,
    familyName: true,
    email: true,
    phoneNumber: true,
    createdOn: false,
    appVersion: false,
    licensePlate: false
}

export const USERS_TABLE_OPTIONAL_COLUMNS: OptionalColumn[] = [
    { accessorKey: 'createdOn', displayNameId: 'COLUMN_CREATED_ON' },
    { accessorKey: 'appVersion', displayNameId: 'COLUMN_APP_VERSION' },
    { accessorKey: 'licensePlate', displayNameId: 'COLUMN_LICENSE_PLATE' },
]

export const usersTableColumns: ColumnDef<any, any>[] = [
    {
        id: 'givenName',
        accessorKey: 'givenName',
        header: () => formatMessage({ id: 'COLUMN_FIRST_NAME' }),
        cell: (info) => info.getValue() ? info.getValue() : '',
        enableColumnFilter: true
    },
    {
        id: 'familyName',
        accessorKey: 'familyName',
        header: () => formatMessage({ id: 'COLUMN_LAST_NAME' }),
        cell: (info) => info.getValue() ? info.getValue() : '',
        enableColumnFilter: true
    },
    {
        id: 'email',
        accessorKey: 'email',
        header: () => formatMessage({ id: 'COLUMN_EMAIL' }),
        cell: (info) => info.getValue() ? info.getValue() : '',
        enableColumnFilter: true
    },
    {
        id: 'phoneNumber',
        accessorKey: 'phoneNumber',
        header: () => formatMessage({ id: 'COLUMN_PHONE_NUMBER' }),
        cell: (info) => info.getValue() ? info.getValue() : '',
        enableColumnFilter: false
    },
    {
        id: 'licensePlate',
        accessorFn: (row) => row.licensePlate?.licensePlate ?? '',
        header: () => formatMessage({ id: 'COLUMN_LICENSE_PLATE' }),
        //cell: (info) => info.getValue() ? info.getValue() : '',
        cell: ({ row }) => <LicensePlate llp={row.original.licensePlate} />,
        enableColumnFilter: true,
        enableSorting: false
    },
    {
        id: 'appVersion',
        accessorKey: 'appVersion',
        header: () => formatMessage({ id: 'COLUMN_APP_VERSION' }),
        cell: (info) => info.getValue() ? info.getValue() : '',
        enableColumnFilter: false
    },
    {
        id: 'createdOn',
        accessorKey: 'createdOn',
        header: () => formatMessage({ id: 'COLUMN_CREATED_ON' }),
        cell: (info) => info.getValue() ? moment(info.getValue()).format('D/MM/YYYY') : '',
        enableColumnFilter: false
    },
    {
        id: 'actionButtons',
        header: () => formatMessage({ id: 'COLUMN_ACTIONS' }),
        cell: ({ row }) => (<UserActionButtons user={row.original} />),
        enableColumnFilter: false
    }
]
